import React, { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import axios from "axios";
import { useDispatch } from "react-redux";
import { BASE_URL } from "../utils/constants";
import { addUser } from "../utils/userSlice";
import { Outlet, useNavigate,useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const Body = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  // const isDetailPage = location.pathname.includes("/materialList/materialDetail");
  const userData = useSelector((state) => state.user);
  const navigate = useNavigate();
  const fetchProfile = async () => {
    if (userData) return null;

    try {
      const response = await axios.get(BASE_URL + "/profile/view", {
        withCredentials: true,
      });
      dispatch(addUser(response.data));
      // console.log("location",location.pathname)
      return navigate(location.pathname);
    } catch (err) {
      if (err.status === 404) {
        return navigate("/login");
      }
      
      console.log("ERROR: ", err);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  return (
    <>
      <div className="flex flex-col min-h-screen">
        <main className="flex-grow">
          {userData && <Navbar />}
          <Outlet />
        </main>
        {/* <Footer /> */}
      </div>
      {/* {   userData&& <Navbar />
}      <Outlet />
      <Footer /> */}
    </>
  );
};

export default Body;
